import React from 'react';
import { Route, Switch } from 'react-router-dom';
import SiteZones from './siteZones';

export default () => (
  <Switch>
    <Route path="/inventory/sites/:id" exact component={SiteZones} />
  </Switch>
);
